var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"complete"},[_c('v-icon',{staticClass:"complete-icon"},[_vm._v("mdi-check-circle")]),_c('div',{staticClass:"complete-description description",domProps:{"innerHTML":_vm._s(_vm.$t('trade.btc.complete'))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }